module.exports = __webpack_public_path__ + "static/img/2.6d472aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/work1/2.png
// module id = 3vH8
// module chunks = 0